import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { approveFreePlan } from "../../store/actions/userManagement/approveUser";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { getAllUser } from "../../store/actions/userManagement/management";

function ApproveModal({ open, onClose, userId, setShowApproveModal }) {
  const userSubPackagePending = useSelector(
    (state) => state?.user?.userSubPackagePending
  );
  const dispatch = useDispatch();

  const handleApprove = () => {

    dispatch(approveFreePlan({userId, callback: () => setShowApproveModal(false)}));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 540,

          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <img
            src="/Assets/approveIcon.png"
            alt=""
            className="w-12 h-12 mb-5"
          />
          <div>
            <h1 className="font-semibold text-2xl mb-4">
              Approve User Application
            </h1>
            <p className="text-sm mb-4">
              Are you sure you want to make approve this user’s application?
            </p>

            <div className="flex mt-6 w-full items-center">
              <CustomButton
                variant="outlined"
                customColor="#fff"
                children="Cancel"
                width="100%"
                height="44px"
                borderColor="#D0D5DD"
                color="#344054"
                iconWidth="22px"
                margin="0px 25px 0px 0px"
                onClick={onClose}
              />

              <CustomButton
                variant="contained"
                customColor="#159AA8"
                children={"Approve User"}
                width="100%"
                height="44px"
                loading={userSubPackagePending}
                padding="10px"
                color={"#fff"}
                onClick={handleApprove}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ApproveModal;
